import React, { useContext } from "react";
import { Navigate, useParams } from "react-router-dom";
import GratefulDBContext from "../../GratefulDBContext";
import SearchResultItem from "../shared/SearchResultItem";
import "./YearResults.scss";

const YearResults: React.FC = (): JSX.Element => {
  const params = useParams();
  const gratefulDB = useContext(GratefulDBContext);

  const results = params.year ? gratefulDB.listByYear(params.year) : [];
  if (!results.length) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="ui container YearResults">
      <div className="ui divided link items">
        {results.map((entry) => (
          <SearchResultItem entry={entry} key={entry.identifier} />
        ))}
      </div>
    </div>
  );
};

export default YearResults;
